import styled from "styled-components";
import { theme } from "../../styles/theme";

export const WarningBanner = styled.div`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || "768px"};
  margin-top: 16px;
  padding: 16px;

  display: flex;
  align-items: center;
  gap: 12px;

  border-radius: 12px;
  background-color: ${theme.colors.yellow.fundo};

  img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .warning-content {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  p {
    flex: 1;
    text-align: left;
    font-size: ${theme.typography.fontSize.auxiliar};
    line-height: ${theme.typography.lineHeight.auxiliar};
    color: ${theme.colors.gray.Cinza_5};
  }

  button {
    all: unset;
    cursor: pointer;
    white-space: nowrap;
    font-size: ${theme.typography.fontSize.auxiliar};
    font-weight: ${theme.typography.fontWeight.bold};
    color: ${theme.colors.blue.Azul_link};
  }

  @media (max-width: 479px) {
    align-items: flex-start;

    .warning-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
`;
